import React from "react";
import Avatar from "../Avatar";
import moment from "moment";
import { getUserData } from "../../services/userService";
import {
  getEventImage,
  getPostImageSection,
  getRoomImage,
  getVideoThumbnail,
  renderPostText,
  getAppImage,
  getPersonaImage,
} from "../../utils/utils";

const Post = ({ post, startTime, openUserModal, isRoomBody }) => {
  if (post?.roomsMentioned && post.roomsMentioned[0]?.isInstantRoom) {
    return <></>;
  }
  return post.body !== "" &&
    post.usersMentioned &&
    post.usersMentioned.length > 1 ? (
    <div className="relative mt-1" key={post._id}>
      <div className="flex items-center py-1">
        <div className="-space-x-3 flex">
          <div className="inline-flex relative overflow-hidden rounded-full border-2 border-white dark:border-navyGray bg-white dark:bg-navyGray">
            <Avatar
              src={getUserData(post.usersMentioned[0]).profile_picture}
              username={getUserData(post.usersMentioned[0]).username}
              size="xs"
            />
          </div>
          <div className="inline-flex relative overflow-hidden rounded-full border-2 border-white dark:border-navyGray bg-white dark:bg-navyGray">
            <Avatar
              src={getUserData(post.usersMentioned[1]).profile_picture}
              username={getUserData(post.usersMentioned[1]).username}
              size="xs"
            />
          </div>
        </div>
        <div className="flex justify-between items-center w-full">
          <div className="pl-4">
            <p className="text-sm font-normal dark:text-frescoWhite">
              <div className="text-gray-700 dark:text-frescoWhite">
                {renderPostText(post, openUserModal, isRoomBody)}
              </div>
            </p>
            <p className="text-xs font-normal text-darkGray">
              {moment(startTime).fromNow()}
            </p>
          </div>
          <>{getEventImage(post)}</>
          <>{getRoomImage(post)}</>
        </div>
      </div>
    </div>
  ) : post.body !== "" && post.appMentioned && post.appMentioned.length > 0 ? (
    <div className="relative mt-1" key={post._id}>
      <div className="flex items-center py-1 z-40">
        <div className="">
          <div className="pl-2">{getPostImageSection(post)}</div>
        </div>
        <div className="flex justify-between items-center w-full">
          <div className="pl-5">
            <p className="text-sm font-normal dark:text-frescoWhite">
              <div className="text-gray-700 dark:text-gray-300">
                {renderPostText(post, openUserModal, isRoomBody)}
              </div>
            </p>
            <p className="text-xs font-normal text-darkGray">
              {moment(startTime).fromNow()}
            </p>
          </div>
          <>{getAppImage(post)}</>
        </div>
      </div>
    </div>
  ) : post.body !== "" && post.usersMentioned.length > 0 ? (
    <div className="relative mt-1" key={post._id}>
      <div className="flex items-center py-1 z-40">
        <div className="">
          <div className="pl-2">{getPostImageSection(post)}</div>
        </div>
        <div className="flex justify-between items-center w-full">
          <div className="pl-5">
            <p className="text-sm font-normal dark:text-frescoWhite">
              <div className="text-gray-700 dark:text-gray-300">
                {renderPostText(post, openUserModal, isRoomBody)}
              </div>
            </p>
            <p className="text-xs font-normal text-darkGray">
              {moment(startTime).fromNow()}
            </p>
          </div>
          <>{getEventImage(post)}</>
          <>{getRoomImage(post)}</>
          <>{getVideoThumbnail(post)}</>
          <>{getAppImage(post)}</>
          <>{getPersonaImage(post)}</>
        </div>
      </div>
    </div>
  ) : post.body !== "" && post.usersMentioned.length === 0 ? (
    <div className="relative mt-1" key={post._id}>
      <div className="flex items-center py-1 z-40">
        <div className="">
          <div className="pl-2">{getPostImageSection(post)}</div>
        </div>
        <div className="pl-5">
          <p className="text-sm font-normal dark:text-frescoWhite">
            <div className="text-gray-700 dark:text-gray-300">
              {renderPostText(post, openUserModal, isRoomBody)}
            </div>
          </p>
          <p className="text-xs font-normal text-darkGray">
            {moment(startTime).fromNow()}
          </p>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.post._id === nextProps.post._id;
}

export default React.memo(Post, areEqual);
